import getPermission from '@fs/zion-permissions'
import { useEffect, useState } from 'react'
import { isLoggedIn } from '@fs/zion-config'
import useErrorHandlerOverlay from './useErrorHandlerOverlay'

const dashboardPermissions = [
  'RootsTechSpeakerAccessPermission',
  'RootsTechExhibitorAccessPermission',
  'RootsTechSponsorAccessPermission',
  'RootsTechHomelandAccessPermission',
  'RootsTechContentAdminAccessPermission',
  'RootsTechSuperAdminAccessPermission',
]

// FIXME: TECHDEBT: Could we use the role value directly instead of mapping it?
const roleMap = {
  RootsTechSpeakerRole: 'hasSpeakerAccess',
  RootsTechExhibitorRole: 'hasExhibitorAccess',
  RootsTechSponsorRole: 'hasSponsorAccess',
  RootsTechHomelandRole: 'hasHomelandAccess',
  RootsTechContentAdminRole: 'hasContentAdminAccess',
  RootsTechSuperAdminRole: 'hasSuperAdminAccess',
}

export default function usePermissionsAccess() {
  const [permissions, setPermissions] = useState(
    dashboardPermissions.reduce((acc, permission) => {
      acc[permission] = false
      return acc
    }, {})
  )
  const [error, setError] = useState()
  useErrorHandlerOverlay(error)

  useEffect(() => {
    if (!isLoggedIn) {
      return null
    }

    let isCurrent = true
    getPermission(dashboardPermissions, 'RootsTech')
      .then((results) => {
        const newPermissions = results.roleResults.reduce((acc, { roleName, activatorResults: [{ success }] }) => {
          acc[roleMap[roleName]] = success
          return acc
        }, {})
        isCurrent && setPermissions(newPermissions)
      })
      .catch((e) => {
        isCurrent && setError(e)
      })
    return () => {
      isCurrent = false
    }
  }, [])

  return permissions
}
